import { call, put, select, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    searchTalent,
    talentSearchSucceeded,
    talentSearchFailed,
} from '../talentSearch';

function* searchTalentEffect({ payload }) {
    try {
        const requestId = yield select(s => s.talentSearch.requestId);
        const response = yield call(SendApiRequest, {
            url: apiRoutes.globalTalentSearch,
            method: 'GET',
            queryParams: { q: payload.q },
        });
        yield put(
            talentSearchSucceeded({
                requestId,
                buckets: response.buckets,
                counts: response.counts,
                total: response.total,
            }),
        );
    } catch (e) {
        yield put(talentSearchFailed());
    }
}

export const talentSearchSagas = [
    takeLatest(searchTalent.type, searchTalentEffect),
];
